import getTranslatedText from '../../_flux/helper/get_translated_text';
import { replaceSpacesWithDashes } from "../string/replace_spaces_with_dashes";

export function replaceWithOptionalTranslation(
    filterValueToBeTranslated,
    label,
    prefix
) {
    const formattedFilterValueToBeTranslated = replaceSpacesWithDashes(String(filterValueToBeTranslated));
    const translationKey = prefix + '-' + formattedFilterValueToBeTranslated;
    const translation = getTranslatedText(translationKey);

    return translation === translationKey ?
        label :
        translation;
}
